import React from 'react';
import Compiler from '../compiler/Compiler';
import { getImage } from '../../utils/richTextUtils';

import './style.css';

const KovParagraph = ({ item, compilerOptions, baseUrl, children }) => {
  let { imageS, description, $$html } = item;

  if (item?.attachments?.length) {
    imageS = getImage(item, 'ILLUSTRATION');
  }

  return (
    <div className="kov-paragraph">
      {imageS && (
        <figure>
          <div className="img-article-holder left xs">
            <div className="img-article-img">
              <img src={baseUrl + imageS.href} />
            </div>
          </div>
        </figure>
      )}

      <div className="paragraph">
        <Compiler text={$$html} options={compilerOptions} />
      </div>
      <div className="paragraph">
        <Compiler text={description} options={compilerOptions} />
      </div>
      <span className="clearfix"></span>

      {children}
    </div>
  );
};

export default KovParagraph;
